'use client'

import Link from 'next/link'
import type { ComponentProps } from 'react'

import { FieldText } from '@/shared/components/form/form-fields'
import { LoadingButton } from '@/shared/components/feedback/loading-button'
import { Form } from '@/shared/components/ui/form'
import { cn } from '@/shared/utils/cn'
import { useForgotPasswordForm } from '../hooks/use-forgot-password-form'


export function ForgotPasswordForm({ className, ...props }: ComponentProps<'div'>) {
  const { form, isSuccess, isLoading, errorMessage, onSubmit } = useForgotPasswordForm()

  return (
    <div className={cn('flex flex-col gap-6', className)} {...props}>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
          <FieldText name="tenant" label="Müşteri Kodu" autoComplete="organization" />
          <FieldText name="email" label="E-posta" type="email" autoComplete="email" />

          {isSuccess && (
            <p role="status" className="rounded-md border border-primary/20 bg-primary/5 px-4 py-3 text-sm text-primary">
              Parola sıfırlama talebiniz alındı. E-posta adresinizi kontrol edin.
            </p>
          )}

          {errorMessage && (
            <p role="alert" className="text-sm text-destructive">{errorMessage}</p>
          )}

          <LoadingButton type="submit" className="w-full" loading={isLoading}>
            Sıfırlama bağlantısı gönder
          </LoadingButton>
        </form>
      </Form>

      <p className="text-center text-sm text-muted-foreground">
        Parolanızı hatırladınız mı?{' '}
        <Link href="/login" className="font-medium text-foreground underline-offset-4 hover:underline">
          Giriş yapın
        </Link>
      </p>
    </div>
  )
}
